import { render } from "./Progress.vue?vue&type=template&id=39a4c286"
import script from "./Progress.vue?vue&type=script&lang=ts"
export * from "./Progress.vue?vue&type=script&lang=ts"
script.render = render

export default script